"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z",
    fill: "url(#whatsapp_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.158 18.014c-.277-.14-1.636-.807-1.889-.9-.253-.092-.438-.138-.623.14-.183.276-.713.898-.874 1.082-.161.185-.323.208-.6.07-.275-.14-1.166-.43-2.222-1.372-.821-.733-1.377-1.638-1.538-1.915-.16-.276-.017-.426.121-.564.125-.123.277-.323.415-.483.139-.162.184-.278.277-.463.092-.184.047-.345-.023-.483-.07-.139-.622-1.5-.852-2.053-.225-.539-.453-.465-.622-.475-.177-.007-.354-.01-.53-.009-.185 0-.484.069-.737.346-.253.276-.968.945-.968 2.306 0 1.36.991 2.674 1.129 2.86.138.183 1.95 2.976 4.722 4.173.66.284 1.174.455 1.576.581.662.211 1.265.181 1.74.11.531-.08 1.635-.669 1.866-1.314.23-.646.23-1.2.16-1.315-.068-.115-.252-.184-.53-.322h.002ZM16.114 24.9h-.003a9.18 9.18 0 0 1-4.68-1.282l-.336-.2-3.48.914.929-3.393-.219-.348a9.171 9.171 0 0 1-1.404-4.893c0-5.069 4.126-9.193 9.197-9.193a9.13 9.13 0 0 1 6.5 2.695 9.139 9.139 0 0 1 2.69 6.506c-.002 5.07-4.126 9.194-9.194 9.194ZM23.94 7.88a10.989 10.989 0 0 0-7.826-3.244c-6.097 0-11.06 4.962-11.062 11.061 0 1.95.509 3.853 1.477 5.53L4.96 26.96l5.865-1.539a11.051 11.051 0 0 0 5.286 1.347h.004c6.097 0 11.06-4.962 11.063-11.062A10.995 10.995 0 0 0 23.94 7.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsapp_svg__a",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43EC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21CB41"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgWhatsapp);
var _default = exports["default"] = Memo;